import { h } from "omi";

export function NoteLoadingSkeleton() {
  return (
    <div class="flex flex-col flex-1">
      <div class="animate-pulse space-y-6">
        <div class="space-y-3">
          <div class="h-4 bg-secondary rounded-md w-full"></div>
          <div class="h-4 bg-secondary rounded-md w-3/4"></div>
          <div class="h-4 bg-secondary rounded-md w-1/4"></div>
        </div>
        <div class="flex items-center space-x-4">
          <div class="h-10 bg-secondary rounded-md w-1/3"></div>
          <div class="h-10 bg-secondary rounded-md w-1/3"></div>
          <div class="h-10 bg-secondary rounded-md w-1/3"></div>
        </div>
      </div>
    </div>
  );
}
